"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.performPostOnboardActions = void 0;

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.promise.js");

require("regenerator-runtime/runtime.js");

var _googleTagManager = require("../../tracking/googleTagManager");

var _storage = require("../../util/storage");

var _trackingHelper = require("../../tracking/trackingHelper");

var _userActions = require("../../redux/user/userActions");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var performPostOnboardActions = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
    var wasNewUser, business_unit_source, business_unit_feature, freshUserContext, cookie;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            wasNewUser = _ref.wasNewUser, business_unit_source = _ref.business_unit_source, business_unit_feature = _ref.business_unit_feature;
            (0, _googleTagManager.setGTMLoggedIn)();
            _context.next = 4;
            return (0, _userActions.fetchUserContext)();

          case 4:
            freshUserContext = _context.sent;
            (0, _userActions.identifyUser)({
              userContext: freshUserContext,
              hasIdentified: false
            });

            if (wasNewUser) {
              (0, _storage.setAllStorage)('zolaUserCreatedAt', new Date().toISOString());
              cookie = (0, _storage.getCookie)('pkey');

              if (cookie === '') {
                cookie = null;
              }

              (0, _trackingHelper.trackUserCreated)(freshUserContext.email, cookie);
            }

            (0, _userActions.identifyUserSailthru)(freshUserContext.email, wasNewUser ? {
              business_unit_source: business_unit_source,
              business_unit_feature: business_unit_feature
            } : undefined).catch(function () {
              return undefined;
            });
            return _context.abrupt("return", freshUserContext);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function performPostOnboardActions(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.performPostOnboardActions = performPostOnboardActions;